// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-c923d6de]{display:block;height:100%;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent}.logo[data-v-c923d6de],.logo[data-v-c923d6de]:hover{outline:none}.logo.size_s[data-v-c923d6de]{height:20px}.logo.size_md[data-v-c923d6de]{height:34px}img[data-v-c923d6de]{max-height:100%}", ""]);
// Exports
module.exports = exports;
